const ITEMS = [
    "THE BEST NEW MUSIC",
    "CURATED BY PROFESSIONALS",
    "SELECT MOVIES & TV",
    "NO FILLER",
    "DISCOVER NEW ARTISTS",
    "HEAR NEW SOUNDS",
    "WATCH RIVVR MUSICTV",
    "ENJOY MUSIC & MOVIES",
    "ONE STREAM · ONE RIVVR",
];

function Row({ hidden }) {
    return (
        <div
            aria-hidden={hidden || undefined}
            className="flex shrink-0 items-center"
        >
            {ITEMS.map((item, i) => (
                <span key={i} className="flex items-center">
                    <span className="px-8 font-display text-sm font-bold uppercase tracking-[0.35em] text-ghost sm:text-base">
                        {item}
                    </span>
                    <svg
                        viewBox="0 0 24 24"
                        className="h-3.5 w-3.5 text-neon/50"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path d="M12 2c1.5 6 4 8.5 10 10-6 1.5-8.5 4-10 10-1.5-6-4-8.5-10-10 6-1.5 8.5-4 10-10z" />
                    </svg>
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <section
            className="relative overflow-hidden border-y border-white/5 bg-obsidian/70 py-3"
            data-testid="marquee-strip"
        >
            <div className="flex w-max animate-marquee">
                <Row />
                <Row hidden />
            </div>
        </section>
    );
}
